<div class="appContainer">
  <div
    id="json-ld"
    [innerHTML]="schema | safe: 'html'"
  ></div>
  @defer {
    <ccf-staff-tools></ccf-staff-tools>
  }
  @if (topMessage && !isBot) {
    <div
      id="topMessageContainer"
      [innerHTML]="topMessage.content | safe: 'html'"
    ></div>
  }
  <div id="topStrip">
    <div class="pageFit">
      <img
        src="/images/dynamic/gen/banner.png"
        alt="Charlies Logo"
      />
    </div>
    <div class="strip">
      <div class="pageFit">
        <div
          class="welcomeMessage"
          [hidden]="!loggedIn"
        >
          &nbsp;<a
            class="goHome"
            [routerLink]="userHome"
            >{{ welcomeMessage }}</a
          >&nbsp;
          <div class="accountType">
            <a
              class="goHome"
              [routerLink]="userHome"
              >{{ dashboardText }}</a
            >
          </div>
        </div>

        <!--<div class='pdf_display' *ngIf='!(accountType === "Wholesale" || accountType === "Staff")'>
            <div>
              <a target='_blank' href='/pdfs/2026/Christmas%20-%20Brochure.pdf?v=20260919'>
                <img src='/images/dynamic/gen/christmas-cover.jpg' alt='' /><br />
                <span class='topTexts'>Christmas Brochure</span>
              </a>
            </div>
            <div class='orderSheetLink'>
              <a [routerLink]="'/OrderSheet/Christmas/Order'">
                Order<span> Sheet</span>
              </a>
            </div>
          </div>!-->

        <div
          class="fundOrderSheet"
          [hidden]="!fundraisingActive"
        >
          <a [routerLink]="'/Fundraising/Christmas/Order'">Fundraising OrderSheet</a>
        </div>

        <ccf-search-bar></ccf-search-bar>

        <div class="bestSellers">
          <a [routerLink]="'/products/Best-Sellers'"> Best Sellers </a>
        </div>
      </div>
    </div>
  </div>

  <div id="header">
    <div id="scrollToTop">
      <div>
        <div (click)="scrollToTop()">Scroll to Top</div>
      </div>
    </div>

    <!--<button type='button' style='position:fixed' (click)='makeError()'>TODO PRE_LAUNCH ERROR TEST</button>!-->

    <div class="logo">
      <a [routerLink]="['/']"
        ><img
          src="/images/dynamic/gen/banner.png"
          alt="Charlies Logo"
      /></a>
    </div>

    <div class="extraNotifications">
      <ul class="notificationsDesktop">
        <li>
          <a
            [routerLink]="['/Holiday-Hours']"
            class="holidayHours"
            [hidden]="!holidayHours"
          >
            <img
              src="/images/static/holiday-hours.png"
              alt=""
            /><br />
            <span class="topTexts">Holiday Hours</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/Contact-Us']"
            class="contactUs"
          >
            <img
              src="/images/static/email-icon.png"
              alt=""
            /><br />
            <span class="topTexts">Contact Us</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/Locations-and-Hours']"
            class="locations"
          >
            <img
              src="/images/static/location-with-map-icon-inverted.png"
              alt=""
            /><br />
            <span class="topTexts">Locations / Hours</span>
          </a>
        </li>
      </ul>

      <ccf-cart-indicator></ccf-cart-indicator>
    </div>

    <ccf-desktop-menubar></ccf-desktop-menubar>
    <ccf-mobile-menu [hidden]="onFrontPage"></ccf-mobile-menu>
  </div>

  <router-outlet></router-outlet>

  <div id="footer">
    <ul class="links">
      <li>&nbsp;</li>
      <li>
        <strong>Company Info</strong>
        <ul>
          <li>
            <a [routerLink]="['/Locations-and-Hours']">Locations &amp; Hours</a>
          </li>
          <li><a [routerLink]="['/Our-Story']">Our Story</a></li>
          <li><a [routerLink]="['/Job-Postings']">Job Postings</a></li>
          <li><a [routerLink]="['/Contact-Us']">Contact Us</a></li>
        </ul>
      </li>

      <li>
        <strong>Shopping</strong>
        <br />
        <ul>
          <li>
            <a [routerLink]="['/Corporate-Logos/Order']">Corporate Logo Order Form</a>
          </li>
          <li>
            <a [routerLink]="['/Frequently-Asked-Questions/Shipping-Policy']">Shipping Policy</a>
          </li>
          <li>
            <a [routerLink]="['/Frequently-Asked-Questions/Return-Exchange-Policy']">Return / Exchange Policy</a>
          </li>
          <li>
            <a [routerLink]="['/Frequently-Asked-Questions/Volume-Discounts']">Volume Discounts</a>
          </li>
          <li>
            <a [routerLink]="['/Frequently-Asked-Questions/Wholesale']">Wholesale Stores</a>
          </li>
        </ul>
      </li>

      <li>
        <strong>Questions</strong>
        <br />
        <ul>
          <li>
            <a [routerLink]="['/Frequently-Asked-Questions']">Frequently Asked Questions</a>
          </li>
          <li><a [routerLink]="['/Donations']">Donations</a></li>
          <li>
            <a [routerLink]="['/Frequently-Asked-Questions/Tours']">Tours</a>
          </li>
          <li><a [routerLink]="['/Fundraising']">Fundraising</a></li>
          <li>
            <a [routerLink]="['/products/Monthly-Specials']">Monthly Specials</a>
          </li>
        </ul>
      </li>
    </ul>

    <div class="bottomlink-text">
      <span
        class="copyright"
        title="No part of this website, the pages contained herein, graphics or prices may be reproduced without the written permission of Charlie&#39;s Chocolate Factory"
        >&copy; &nbsp; {{ currentYear }} Charlie's Chocolate Factory. All rights reserved.</span
      >

      <div class="footer-right">
        <a
          [hidden]="loggedIn"
          class="login"
          (click)="login()"
          >Login</a
        >
        <a
          [hidden]="!loggedIn"
          class="logout"
          (click)="logout()"
          >Logout</a
        >
        <!-- TODO PRE_LAUNCH <a class='viewMobileSite' (click)="browser.setMobile(true)">View Mobile Site</a> !-->
        <!-- TODO PRE_LAUNCH <a class='viewFullSite' (click)='browser.setMobile(false)'>View Full Site</a> !-->

        <span>
          Visit us on
          <a
            class="facebook"
            rel="noopener"
            href="https://www.instagram.com/charlieschocolates/"
            target="_blank"
            ><img
              src="/images/static/instagram.png"
              width="24"
              height="24"
              alt="Link to Instagram"
          /></a>
          <a
            class="facebook"
            rel="noopener"
            href="https://www.facebook.com/charlieschocolate"
            target="_blank"
            ><img
              src="/images/static/minifb.gif"
              width="24"
              height="24"
              alt="Link to facebook"
          /></a>
        </span>
      </div>
    </div>
  </div>
</div>
